const constants = {
  notify: 'USER_NOTIFY',
  denotify: 'USER_DENOTIFY',
  set: 'USER_SET',
};

const notify = (notification) => ({
  type: constants.notify,
  payload: notification,
});

const denotify = (notification) => ({
  type: constants.denotify,
  payload: notification,
});

const set = (user) => ({
  type: constants.set,
  payload: user,
});

const userActions = {
  constants,
  notify,
  denotify,
  set,
};

export default userActions;
